// extracted by mini-css-extract-plugin
module.exports = {"blockUi":"BlockUi_blockUi__34FR9","spinner":"BlockUi_spinner__2645b","spinnerLabel":"BlockUi_spinnerLabel__1yi7q"};